import React from 'react';
import '../styles/SentakuStyle.css'

import SentakuA from './SentakuA';
import SentakuB from './SentakuB';
import SentakuC from './SentakuC';

function Sentaku() {

  return (
    <div id='sentakuDiv'> 

    <SentakuA/>
    <SentakuB/>
    <SentakuC/>

    </div>
  )
}

export default Sentaku
